// extracted by mini-css-extract-plugin
export default {"down":"DropdownTemplate_down__RhwJb","up":"DropdownTemplate_up__BI2v9"};